<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.custom.market.name')+'*'"
                    v-model="formData.name"
                    :rules="nameRules"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-radio-group v-model="formData.gender" row>
                    <v-radio :label="$vuetify.lang.t('$vuetify.custom.student.man')"
                             :value="0"></v-radio>
                    <v-radio :label="$vuetify.lang.t('$vuetify.custom.student.women')"
                             :value="1"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="12">
                <el-select v-model="formData.schoolId"
                           style="width: 94vw"
                           filterable
                           placeholder="选择学校">
                    <el-option
                        v-for="item in schoolItems"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
            </v-col>
            <v-col cols="12">
                <el-select v-model="formData.intention"
                           style="width: 94vw"
                           filterable
                           placeholder="选择意向">
                    <el-option
                        v-for="item in intentionItems"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
            </v-col>
            <v-col cols="12">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.custom.market.profession')+'*'"
                    v-model="formData.specialities"
                    :rules="[rules.required]"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.custom.market.phone')+'*'"
                    v-model="formData.phone"
                    :rules="phoneRules"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.custom.market.qq')+'*'"
                    v-model="formData.qq"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.custom.market.wechat')+'*'"
                    v-model="formData.wechat"
                ></v-text-field>
            </v-col>
            <v-col :class="bottomStyle" cols="12">
                <el-select
                    style="width: 94vw"
                    v-model="formData.source"
                    clearable
                    placeholder="请选择学生来源"
                    @change="sourcesChanges">
                    <el-option
                        v-for="item in sourceItems"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
            </v-col>
            <v-col cols="12" v-show="othersFlag">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.custom.market.others')+'*'"
                    v-model="formData.other"
                ></v-text-field>
            </v-col>
            <v-btn class="mb-14 ml-3" width="94vw" color="success" dark @click="updateStu">
                {{ $vuetify.lang.t('$vuetify.custom.market.updateClue') }}
            </v-btn>
        </v-row>
    </v-form>
</template>
<script>
export default {
    data() {
        return {
            imgUrl:'',
            bottomStyle: 'mb-6',
            othersFlag: false,
            stuValue: '',
            nameRules:[
                v => !!v || '姓名必填',
                v => typeof v === "undefined" || v.length <= 32 || '姓名不能超过32位',
            ],
            phoneRules:[
                v => !v || /^1[3456789]\d{9}$/.test(v) || '手机号格式错误'
            ],
            rules: {
                required: value => !!value || '请输入'
            },
            sourceItems: [
                {text: '其他', value: '5'},
                {text: '外包', value: '4'},
                {text: '市场活动', value: '3'},
                {text: '招聘会', value: '2'},
                {text: '老学员推荐', value: '1'},
                {text: '讲座', value: '0'},
            ],
            intentionItems:[
                {text: '无意向', value: 0},
                {text: '低意向', value: 1},
                {text: '高意向', value: 2},
            ],
            schoolItems: [
            ],
            formData: {
                id: '',
                name: '',
                gender: 0,
                schoolId: '',
                intention: '',
                specialities: '',
                phone: '',
                qq: '',
                wechat: '',
                source: '',
                other: '',
            },
        }

    },
    watch: {},
    created() {
        this.initSchoolItems()
        this.formData.id = this.$route.query.id
        this.initUpdateMsg()
    },
    methods: {
        lookDetail(itemData){
            this.$publish.publish("updateTitle","查看详情")
            this.$publish.publish("updateArrow",true)

            this.$router.push({
                path:"/marketDetail",
                query:{
                    id:itemData.id
                }
            })
        },
        initUpdateMsg(){
            this.$api.clew.queryDetail({"id": this.formData.id}).then(data => {
                if (data.data) {
                    this.formData = {...data.data}
                    this.sourcesChanges()
                }
            })
        },
        updateStu() {
            if (this.$refs.form.validate()) {
                this.$api.clew.updateClew(this.formData).then(data => {
                    if (data.flag) {
                        this.popErrorMsg("修改成功");
                        this.lookDetail(this.formData)
                    }else{
                        this.popErrorMsg("已存在");
                    }
                })

            }

        },
        initSchoolItems() {
            this.$api.school.getSchoolSelect().then(data => {
                if (data.data) {
                    data.data.forEach(obj => {
                        this.schoolItems.push({text: obj.schoolName, value: obj.id})
                    })
                }
            })
        },
        popErrorMsg(msg){
            this.$message({
                dangerouslyUseHTMLString:true,
                center:true,
                message: '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAE+klEQVR4Xu2bSYhdRRSG/x/duFEcQBQnxGmjC0VU1OBEopiIuugI6sJAYnDAKA5gFurCLJxinKJRzEJFjKBiDGo0A0YxERVEEIUoGI1GkICCCE6//J3bzWv63Xur3q2qfqT7LLtPnfPXd8+9t6rOfcQ0N07z+WMGwEwFTAEBSfcCOBXAaQD+A/AxgK9I+u9FrfgtIGkxgJU1s1xI8rmSBIoCkHQ2gA9bJngOyY9KQSgN4E0A81omt5bkZXsdAEkLAawKnNgiks8G+nZyK1IBkg6tSv+4QLXbAfhW+CXQf2C3UgAeAXBrpMrlJG+LHBPtnh2ApPMBbIxWtmfABSQ3DTg2aFgJAG8DuDhIzWSnd0heMuDYoGFZAUi6AcCTQUrqnW4k+VTHGLXDswGQdGT14Duqo/gd1QPxh45x+g7PCeBxADclEv0EyZsTxZoQJgsASbMBvNsieB2A7wH8BeBYAG2Lnzkk16eGkAvABj/BG8TOJvle7/8lLQGwvGHMRpIXDj0ASbcAeLRB6H11uz5JVwF4uWHsEpIrUkJIWgGSXMre7BxWI3InySOaJiBpJ4DDa3x+rh6I36WCkBrAMwAWNYjbTNILo1qT5IXPeQ0uq0heP3QAJM0FsLZFWAoATjGP5FspICSrAEkfADi3EIAtJGcNDQBJdwB4IEBQqgpwqjtJPhiQs9GlcwVIOgnAFgCHBIhJCeBXVxzJrwPy1rqkAPA8gOsCRaQE4JSrSS4IzN3XrRMASVcAeC1CQGoATn0lydcjNExwHRiApH2rd/4ZEclzANhWrQ3+idAx7toFwN0A7o9MmgOAJSwluSxSy6j7QAAknVxd/f0jk+YC8HtVBV9G6hkYwIsAro5NBiAXAEt5ieQ1sZqiK0DSCIBXYhNV/jkBOMV8kmtitEUBkLRfVfru6w1iuQF8Xt0Kf4aKiwXg5uU9ocH7+OUG4JS12+1+uoMBSHIn1ys+V8GgVgKAr75XiJ+FiIwB4Pve938XKwHA+taQnB8iNAiAJD9dXwgJ2OJTCoBlXEvSb6tGawUg6YCq9P3u72rbSJ7ZFETSp9WHE11zeU3gW+G3pkAhALza86ovhe0meXALgN0ADkyRDMAykksHBiDJV8tnfPskEuQwK0m6YzTJJPk4zcdqqezf6rW4tS5gYwVI8i7r8lRqeuKMkHy1N66kxwDkaH68QdK71r5WC0CS9/je6+eyH6uPo/6oDkGPyZUIwAKSq/vF7wtAkk93XPonZhRVMvQ31a3gU6QJVgfAZ223l1RYINdDJH122QxAkk92fcK7N9oskl7NjtukCpDk8/ZLC8w+tjmaQtI6ku5f9AcgyR2Xp1NkaokxSHM0lazFJMdfteMVIMn9OJeH+3s5rUtzNIUu9xW9QvzJwXoBuKPrzm5O20WyrnE6mlfSLgD+rC6nrSDpdvweAJLcd38/Z8Yq9laSZzXlkfQJgNMLaLmI5IYxAP6aw1915LbtJI9vAfBtgdvQEtaTnMMBmhtdIc0l6TfAJKsOXbwbLGUjBtD1mCtW7A6SR9cA+ALAKbEBO/g/bABtHyR0iF871PsAfz/ocv8bwAkA7gJwUI5kDTE3T0UFFJ5jY7rRCohtcA7TBLpqGRl7C5R+DnQVnmL86IKsdyHU+0Omuq+0UiSeyhhjZxDjP9BqPROcSrUlcs8AKEF5mHPMVMAwX50S2qZ9BfwPh83Dwh2h2Q8AAAAASUVORK5CYII="/><div style="color: white;margin-left: 17%">'+msg+'</div>',
                offset:260,
                duration:3000,
                customClass:'myStyle',
                iconClass:'myIconStyle',
            });
        },
        sourcesChanges() {
            if (this.formData.source == 5) {
                this.bottomStyle = ''
                this.othersFlag = true
            } else {
                this.othersFlag = false
                this.bottomStyle = 'mb-6'
            }
        },

    },
    components: {},
}
</script>
<style>
.myStyle{
    min-width: 160px!important;
    background:rgba(0, 0, 0, 0.4)!important;
}
</style>
